import styled from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  align-items: center;
  height: 2.5rem;
  padding-right: 2rem;
`;
export const Claim = styled.div `
  color: ${({ theme }) => theme.colors.grey11}; // to be done waiting for feedback
  display: block;
  font-size: 0.75rem;
  line-height: 1;
  margin-left: 0.5rem;
  word-break: normal;
  align-self: baseline;
`;
export const Link = styled.a `
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 0.625rem 0;
  border: 1px solid transparent;
  outline: none;
  outline-offset: 0;

  ${({ theme, focusVisible }) => focusVisible ? `border: 1px solid ${theme.colors.primaryLight}` : ''};

  ${({ theme, focusVisible }) => focusVisible ? `outline: 1px solid ${theme.colors.primaryLight}` : ''};
`;
export const Image = styled.img `
  width: 9.125rem;
  height: 1.25rem;
`;
